<template>
  <div class="info-box">
    <div class="carbox">
      <div class="carlist" v-for="(item,index) in list" :key="index"
           :class="{'active' : selectCardNos.includes(item.cardNo), 'gary': item.lost || item.frozen}"
           @click="select(item)">
        <div class="card-top">
          <b>卡号:{{item.cardNo}}</b>
          <span v-if="item.lost && item.frozen">状态:挂失/冻结</span>
          <span v-if="item.lost && !item.frozen">状态:挂失</span>
          <span v-if="!item.lost && item.frozen">状态:冻结</span>
          <span v-if="!item.lost && !item.frozen">状态:正常</span>
        </div>
        <div class="pre">余额：{{item.cardBalance}}</div>
        <img src="@/assets/xz.png">
      </div>
    </div>
  </div>
</template>

<script>
  import {getCampusCard} from "@/api/my/my";

  export default {
    name: "campusCard",
    props: {
      selectable: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        list: [
          // {cardNo: '202300103', lost: true, frozen: true, cardBalance: 20},
          // {cardNo: '202307703', lost: true, frozen: false, cardBalance: 100},
          // {cardNo: '111', lost: false, frozen: false, cardBalance: 0},
          // {cardNo: '222', lost: false, frozen: false, cardBalance: 10},
          // {cardNo: '333', lost: false, frozen: false, cardBalance: 20}
        ],
        selectCard: []
      }
    },
    computed: {
      selectCardNos() {
        if (this.selectCard.length > 0) {
          return this.selectCard.map(i => i.cardNo)
        } else {
          return []
        }
      }
    },
    created() {
      getCampusCard().then(res => {
        if (res.code === 10000) {
          this.list = res.result
        }
      })
    },
    methods: {
      select(item) {
        if (!this.selectable) return

        // 挂失/冻结不可选
        if (item.lost || item.frozen) return;

        if (this.multiple) {
          this.selectMultiple(item)
        } else {
          this.selectSingle(item)
        }
        this.$emit('change', JSON.parse(JSON.stringify(this.selectCard)))
        this.$forceUpdate()
      },
      // 单选
      selectSingle(item) {
        if (this.selectCardNos.includes(item.cardNo)) {
          // 已选
          this.selectCard = []
        } else {
          // 未选
          this.selectCard = [item]
        }
      },
      // 多选
      selectMultiple(item) {
        if (this.selectCardNos.includes(item.cardNo)) {
          // 已选
          this.selectCard = this.selectCard.filter(i => i.cardNo != item.cardNo)
        } else {
          // 未选
          this.selectCard.push(item)
        }
      },
    }
  }
</script>

<style scoped>

  .carbox {
    padding: 0 15px;
  }

  .info-box {
    background: #ffffff;
  }

  .carlist {
    background: #2C68E4;
    border-radius: 3px;
    display: flex;
    margin: 10px 0;
    background: linear-gradient(90deg, #3399FF 0%, #88B0FF 100%);
    height: 80px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .carlist img {
    display: none;
  }

  .active img {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 30px;
    height: 30px;
  }

  .card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .card-top b {
    font-size: 16px;
    color: #ffffff;
  }

  .card-top span {
    font-size: 16px;
    color: #ffffff;
    font-weight: bold;
  }

  .pre {
    color: #ffe400;
    font-size: 18px;
    font-weight: bold;
  }

  .gary {
    background: #ededed;
  }

  .gary .card-top b {
    font-size: 15px;
    color: #999999;
  }

  .gary .card-top span {
    font-size: 15px;
    color: #999999;
    font-weight: bold;
  }

  .gary .pre {
    color: #999999;
    font-size: 18px;
    font-weight: bold;
  }
</style>
